// The page that embeds us is the whitelabel-builder app, which for the ConnectAmericas tenant
// is served from the `wl-ca-*` hosts — NOT from connectamericas.com, which is still the legacy
// Drupal site. Both are listed: the Drupal domains so the calculator keeps working if a legacy
// page embeds it or once the app takes over the apex domain, and the whitelabel host because
// that is where the resize handshake actually comes from today. An origin missing from this
// list fails silently in exactly one way — the parent never hears our height and falls back to
// its configured vh height — so add new embedding hosts here or via REACT_APP_PARENT_ORIGINS.
const DEFAULT_PARENT_ORIGINS = [
  "https://wl-ca.connectamericas.com",
  "https://wl-ca-stage.connectamericas.com",
  "https://connectamericas.com",
  "https://www.connectamericas.com",
  "https://stage.connectamericas.com",
];

// The parent only runs on these during local development (port 3001, wildcard cert). Keeping
// them out of the production allowlist means a production build can never report our layout to
// a page served from the viewer's own machine.
const DEV_PARENT_ORIGINS = ["https://local-ca.connectamericas.com:3001", "https://localhost:3001"];

// Origins allowed to embed us in an iframe and ask for our content height. Comma-separated in
// REACT_APP_PARENT_ORIGINS; see src/utils/iframeResizeBridge.js for how it is used.
const parseParentOrigins = (value) => {
  if (!value) {
    return process.env.NODE_ENV === "production"
      ? DEFAULT_PARENT_ORIGINS
      : [...DEFAULT_PARENT_ORIGINS, ...DEV_PARENT_ORIGINS];
  }

  return value
    .split(",")
    .map((origin) => origin.trim().replace(/\/+$/, ""))
    .filter(Boolean);
};

export const URLs = {
  apiUrl: process.env.REACT_APP_API_URL,
  jsUrl: process.env.REACT_APP_JS_URL,
  imgUrl: process.env.REACT_APP_IMAGE_URL,
  connectAmericasApiUrl: process.env.REACT_APP_CONNECT_AMERICAS_API_URL,
  gaTrackingId: process.env.REACT_APP_GA_TRACKING_ID,
  casUrlAuth: process.env.REACT_APP_CAS_URL_AUTH,
  serviceUrlAuth: process.env.REACT_APP_SERVICE_URL_AUTH,
  registerUserUrl: process.env.REACT_APP_REGISTER_USER_URL,
  parentOrigins: parseParentOrigins(process.env.REACT_APP_PARENT_ORIGINS),
};
